module.exports = __webpack_public_path__ + "img/jwgl-kbcx-wdkb.7b3a267d.png";